module.exports = __webpack_public_path__ + "img/Weapon_126.9197f1b8.png";